import React from 'react'
import Component from '../common/Component'
import BenefitsSetBulkEditsComponent from '../BenefitsSet/BenefitsSetBulkEditsComponent'
import fieldGroups, { benefitLabels, metadatumFieldsDiffSet } from './accidentFields'

const defaultFields = {
  default: {
    values: [
      'hios_ids',
      'id',
      'vericred_id',
      'name',
      'issuer_name',
      'voluntary',
      'effective_date',
      'expiration_date',
      'privileged_data',
      'plan_years',
      'voluntary',
      'portability',
      'twenty_four_hour',
      'rate_guarantee',
      'accidental_death_dismemberment_included',
      'accidental_death_benefit_employee',
      'accidental_death_benefit_spouse',
      'accidental_death_benefit_child',
      'common_carrier_death_benefit_employee',
      'common_carrier_death_benefit_spouse',
      'common_carrier_death_benefit_child'
    ],
    pinned: ['id', 'vericred_id', 'sbc_url', 'sob_url']
  }
}

export default class AccidentBenefitsSetBulkEditsComponent extends Component {
  render() {
    return (
      <BenefitsSetBulkEditsComponent
        benefitLabels={benefitLabels}
        metadatumFields={metadatumFieldsDiffSet}
        defaultFields={defaultFields}
        benefitsSetUrl="/accident_benefits"
        productLine="accident"
        fieldGroups={fieldGroups}
        includeSbcCheckbox
        sbcCheckboxLabel="Build from Benefit Summaries"
        hideSobUrl
        {...this.props}
      />
    )
  }
}
